import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";

createCycles();
runPageIn();
runMount();

import { TextAnimations } from "@/modules/text-animations";
import { CoinsAnimation } from "@/modules/coins-animation";
import { Accordion } from "@/modules/accordion";
import { Tabs } from "@/modules/tab";

const accordion = new Accordion();
accordion.init();
const textAnimations = new TextAnimations();
textAnimations.init();
const footerCoins = new CoinsAnimation('riveFooter', 'footerSection', -0.8, "top bottom", "bottom 20%")
footerCoins.init()
const tabs = new Tabs();
tabs.init();


history.scrollRestoration = "manual";
window.scrollTo(0, 0);